// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1l_cw","footer":"ModalInfo_footer__3Upea"};